import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { MdPause } from 'react-icons/md';
import { FaRegUser } from 'react-icons/fa';
import { IoIosMore } from 'react-icons/io';
import { useRouter } from 'next/router';
import { FaCirclePlay } from 'react-icons/fa6';

type PromoterActionModalProps = {
  onClose: () => void;
  promoterId: string;
  handlePausePromoter: () => void;
  isPaused: boolean;
};

const PromoterActionModal: React.FC<PromoterActionModalProps> = ({
  onClose,
  promoterId,
  handlePausePromoter,
  isPaused
}) => {
  const { t } = useTranslation(['events']);
  const router = useRouter();
  const buttonText = isPaused
    ? t('settings.promoterOffers.modals.promoterActions.resumePromoter')
    : t('settings.promoterOffers.modals.promoterActions.pausePromoter');
  return (
    <Modal
      visible
      autoHeight
      onClose={onClose}
      type={ModalType.SMALL}
      title={t('settings.promoterOffers.modals.promoterActions.title')}
      icon={<IoIosMore size={20} />}
    >
      <div className="mx-4">
        {/* <div className="flex flex-col gap-2 mt-6">
        <Button
          type={ButtonType.Inverted}
          onClick={() => null}
          icon={
            <img
              src="/img/events/create/offer-blue.svg"
              height={16}
              width={16}
            />
          }
        >
          Promoter Details
        </Button>
      </div> */}
        <div className="flex flex-col gap-2 mt-6">
          <Button
            type={ButtonType.Inverted}
            onClick={() => {
              router.push(`/profile/${promoterId}`);
            }}
            icon={<FaRegUser size={16} />}
          >
            {t('settings.promoterOffers.modals.promoterActions.viewProfile')}
          </Button>
        </div>
        <div className="flex flex-col gap-2 mt-6">
          <Button
            type={ButtonType.Inverted}
            onClick={handlePausePromoter}
            icon={isPaused ? <FaCirclePlay size={20} /> : <MdPause size={20} />}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PromoterActionModal;
